import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import TitleField from '../../fields/TitleField';
import FlagsField from '../../fields/FlagsField';
import DescriptionField from '../../fields/DescriptionField';
import PriceField from '../../fields/PriceField';
import TagsField from '../../fields/TagsField';
import DisplayOptionsField from '../../fields/DisplayOptionsField';

import s from './FirstStep.scss';

interface Props {
  deviation?: PapiDeviation;
}

const FirstStep: React.FC<Props> = ({ deviation }) => {
  const showDisplayOptions = deviation && !deviation.isDefaultImage;
  return (
    <div className={s['root']}>
      <TitleField />
      <FlagsField />
      <DescriptionField />
      <PriceField />
      <TagsField noBottomSpacing={showDisplayOptions} />
      {showDisplayOptions && <DisplayOptionsField deviation={deviation} />}
    </div>
  );
};
FirstStep.displayName = 'FirstStep';

export default FirstStep;
